<template>
  <b-col>
    <b-button
      id="download-button"
      md="6"
      class="my-1"
      @click="downloadData"
      variant="primary"
      >Download Data</b-button
    >
  </b-col>
</template>
<script>
import jsonexport from 'jsonexport';
import { mapGetters } from 'vuex';

export default {
  name: 'DownloadButton',
  props: {
    export: Array,
    file: String,
  },
  computed: {
    ...mapGetters({
      getMonths: 'getMonths',
    }),
  },
  methods: {
    downloadData() {
      const route = this.file;
      const months = this.getMonths;
      jsonexport(this.export, (err, csv) => {
        if (err) return console.error(err);
        (function downloadCSV(args) {
          if (csv === null) return;
          const now = new Date();
          const date = now.getDate();
          const year = now.getFullYear();
          const month = months[now.getMonth()];
          const fileName = `${route} - ${year}_${month}_${date}.csv`;
          if (!csv.match(/^data:text\/csv/i)) {
            csv = `data:text/csv;charset=utf-8,${csv}`;
          }
          const data = encodeURI(csv);
          const link = document.createElement('a');
          link.setAttribute('href', data);
          link.setAttribute('download', fileName);
          link.click();
        })();
      });
    },
  },
};
</script>

<style>
#download-button {
  float: right;
}
</style>
